import "./index.css";
function Footer() {
  return <>
    <div className="footer-content-page">
        
        <div className="footer-title">
            <p>Powered By</p>
        </div>
        <div className="logo">
            <img src="https://d33wubrfki0l68.cloudfront.net/e6fddcbea146f91d2f3c160f7d56a9391a4740b0/4e758/static/logo-51c754388b198e5bbb0d08a971ebbfa2.png" alt="Logo" />
        </div>
    </div>
  </>;
}
export default Footer;